import type { RoomAvailability } from './models/rooms'

export async function checkRoomAvailabilities(
    roomIds: string[],
    checkRoom: (roomId: string) => Promise<boolean>,
    onRoomError: (roomId: string, error: unknown) => void,
): Promise<Record<string, RoomAvailability>> {
    const results = await Promise.all(
        roomIds.map(async (roomId): Promise<[string, RoomAvailability]> => {
            try {
                return [roomId, await checkRoom(roomId)]
            } catch (error) {
                onRoomError(roomId, error)
                return [roomId, 'error']
            }
        }),
    )

    return Object.fromEntries(results)
}
